export default {
  sidebar: [
    {
      name: 'Basic',
      path: 'basic'
    },
    {
      name: 'Social',
      path: 'social'
    }
  ]
}
